import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import { Button, Input, Card, Table, Row, Col, Tag } from "antd";
import moment from "moment";
import { toast } from "react-toastify";
import { get, post, responseValidator } from "../../../api";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import Loading from "../../../loading/loading.index";

export default function Confirmverification() {
    const [loading, setLoading] = useState(false);
    const [docs, setDocs] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef();
    const allData = [];

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText("");
    };

    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={` جستجو ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <div>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        پاک کردن
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        فیلتر
                    </Button>
                </div>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined
                style={{ color: filtered ? "#1890ff" : undefined }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : "",
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (
                text
            )
    });

    useEffect(() => {
        setLoading(true);
        get("/AuthSurvey/1000000/1").then(response => {
            setLoading(false);
            if (responseValidator(response.status)) {
                console.log(response.data.data);
                response.data.data.map((item, index) => {
                    allData.push({
                        key: item.id,
                        fullName:
                            item.userFullname === " "
                                ? "تنظیم نشده است"
                                : item.userFullname,
                        username:
                            item.username !== null
                                ? item.username
                                : "تنظیم نشده است",
                        type: item.type.title,
                        state: item.state.title,
                        // time: (new Date(item.requestDateTime)).toLocaleDateString('fa-IR')
                        time: item.requestDateTime
                    });
                });
                console.log(allData);
                setDocs(allData);
            } else {
                toast.error(response.data.message);
                if (response.status === 403)
                    setTimeout(() => {
                        window.location.replace("/authorization/");
                    }, 3000);
            }
        });
    }, []);

    const columns = [
        {
            title: "نام و نام خانوادگی",
            dataIndex: "fullName",
            key: "fullName",
            render: text => <span className="gx-link">{text}</span>,
            ...getColumnSearchProps("fullName")
        },
        {
            title: "شماره تلفن",
            dataIndex: "username",
            key: "username",
            ...getColumnSearchProps("username")
        },
        {
            title: "نوع مدرک",
            dataIndex: "type",
            key: "type",
            render: text => (
                <>
                    <div color="blue">
                        {text === "MelliCard"
                            ? "کارت ملی"
                            : text === "SelfiPhoto"
                            ? "عکس سلفی"
                            : text === "MeliCardSelfi"
                            ? "مدارک احراز کامل"
                            : "ویدیو سلفی"}
                    </div>
                </>
            ),
            filters: [
                { text: "کارت ملی", value: "MelliCard" },
                { text: "عکس سلفی", value: "SelfiPhoto " },
                { text: "ویدیو سلفی", value: "SelfiVideo" },
                { text: "مدارک احراز کامل", value: "MeliCardSelfi" }
            ],
            onFilter: (value, record) => record.type.indexOf(value) === 0
        },
        {
            title: "وضعیت مدرک",
            dataIndex: "state",
            key: "state",
            render: tag => (
                <>
                    <Tag
                        color={
                            tag === "در انتظار بررسی"
                                ? "orange"
                                : tag === "رد شده"
                                ? "red"
                                : "green"
                        }
                        key={tag}
                    >
                        {tag}
                    </Tag>
                </>
            ),
            filters: [
                { text: "در انتظار بررسی", value: "در انتظار بررسی" },
                { text: "رد شده", value: "رد شده" },
                { text: "تایید شده", value: "تایید شده" }
            ],
            onFilter: (value, record) => record.state.indexOf(value) === 0
        },
        {
            title: "تاریخ",
            dataIndex: "time",
            key: "time",
            sorter: (a, b) =>
                moment(new Date(a.time)).unix() -
                moment(new Date(b.time)).unix(),
            render: date => (
                <>
                    <span>
                        {date.split(":")[0].slice(11, 13) +
                            ":" +
                            date.split(":")[1] +
                            " - " +
                            new Date(date).toLocaleDateString("fa-IR")}
                    </span>
                </>
            )
        },
        {
            title: "عملیات",
            key: "action",
            render: (text, record) => (
                <span>
                    <span
                        className="gx-link"
                        onClick={() =>
                            window.open(
                                "/adminpanel/confirmverification/detail/" +
                                    text.key,
                                "_blank"
                            )
                        }
                    >
                        جزییات
                    </span>
                </span>
            )
        }
    ];

    return (
        <React.Fragment>
            {loading && <Loading />}
            <Row className="docs-page">
                <Col span={24}>
                    {docs && (
                        <Card title="وضعیت صلاحیت مدارک کاربران">
                            <Table
                                loading={loading}
                                pagination={{ pageSize: 8 }}
                                bordered={true}
                                className="gx-table-responsive"
                                columns={columns}
                                dataSource={docs}
                            />
                        </Card>
                    )}
                </Col>
            </Row>
        </React.Fragment>
    );
}
